<template>
  <div style="height: 100%;width: 100%;display: flex;flex-direction: row">
    <PdfView v-if="showPdf" :url="fileItem.sys_file.url" style="width:100%;height: 100%"></PdfView>
    <div v-else-if="showPng" style="width: 100%;height: 99%;overflow:hidden">
      <img id="img" :style="{transform:'scale('+multiples+')'}" :src=fileItem.sys_file.url @mousedown.prevent="dropImage" @mouseup.prevent="loosen" @mousewheel.prevent='gunlun'/>
    </div>
    <div v-else style="width:63%;height: 100%">
      <el-empty description="抱歉，暂不支持非PDF、非图片文件预览"></el-empty>
    </div>

    <div>
      <el-row>
      <el-button  type="primary" style="margin-top: 150px;width: 80px" icon="el-icon-arrow-up"  @click="prcPageUp(fileItem.sys_file.id,fileItem.itemData)"></el-button>
      </el-row>
      <el-row>
        <el-button  type="primary" style="margin-top: 20px;width: 80px" icon="el-icon-arrow-down"  @click="prcPageDown(fileItem.sys_file.id,fileItem.itemData)"></el-button>
      </el-row>
    </div>

  </div>
</template>

<script>

import PdfView from "@/views/applications/mes/PdfView.vue";

export default {
  name: "PrcPdf",
  inject: ['$fn'],
  components:{PdfView},
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      showPdf: false,
      showPng: false,
      fileItem: {},
      currentSub: 0,
      multiples: 1,
      odiv: null,
    }
  },
  created() {
    this.getData()
  },
  methods:{

    getData(){
      if (this.parentData.sys_file.file_suffix.match(".pdf")){
        this.showPdf = true
      }
      if (this.parentData.sys_file.file_suffix.match(".jpg") || this.parentData.sys_file.fileSuffix.match(".png") || this.parentData.sys_file.fileSuffix.match(".jpeg")){
        this.showPng = true
      }
      this.fileItem = this.parentData
    },

    gunlun(e) {
      let direction = e.deltaY > 0 ? 'down' : 'up'
      if (direction === 'up') {
        if (this.multiples >= 10) {
          return;
        }
        this.multiples += 0.25;
        // 滑轮向上滚动
      } else {
        if (this.multiples <= 0.5) {
          return;
        }
        this.multiples -= 0.25;
        // 滑轮向下滚动
      }
    },
    dropImage(e) {
      if (e === null) {
        return
      }
      this.odiv = e.target;        //获取目标元素
      //算出鼠标相对元素的位置
      let disX = e.clientX - this.odiv.offsetLeft;
      let disY = e.clientY - this.odiv.offsetTop;
      document.onmousemove = (e) => {       //鼠标按下并移动的事件
                                            //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
        let left = e.clientX - disX;
        let top = e.clientY - disY;

        //绑定元素位置到positionX和positionY上面
        this.positionX = top;
        this.positionY = left;

        //移动当前元素
        this.odiv.style.left = left + 'px';
        this.odiv.style.top = top + 'px';
      }
    },

    async prcPageUp(fileId,itemData){
      //赋值
      this.fileItem = await this.$http("multipleViewService.prcPageUp",{fileId: fileId, itemData: itemData})
      this.$fn.setWindowTitle(this.fileItem.sys_file.originalName);
    },

    async prcPageDown(fileId,itemData){
      //赋值
      this.fileItem = await this.$http("multipleViewService.prcPageDown",{fileId: fileId, itemData: itemData})
      this.$fn.setWindowTitle(this.fileItem.sys_file.originalName);
    },

    prevPage() {
      if (this.currentSub - 1 < 0) {
        this.$message.error("当前已经是第一页")
      } else {
        this.currentSub--
      }
    },

    nextPage() {
      if (this.currentSub + 1 >= this.fileItem.itemData.length) {
        this.$message.error("当前已经是最后一页")
      } else {
        this.currentSub++
      }
    },
    startVerPage() {
      var lastId = this.fileItem.last_ver.id;
      for (var i = 0; i < this.fileItem.itemData.length; i++) {
        if (this.fileItem.itemData[i].id === lastId) {
          this.currentSub = i
        }
      }
    },

    loosen(){
      document.onmousemove = null;
      document.onmouseup = null;
    }
  },
}
</script>

<style scoped>
.titleText{
  font-size: 30px;
  width: 100%;
  text-align: center;
}
img {
  height: 100%;
  width: auto;
  position: relative;
}
.iconArrow{
  width: 60px;
  height: 55px;
  font-size: 30px;
}
.leftButton{
  position: absolute;
  top: 45%;
  left: 2%;
  margin: auto;
}
.rightButton{
  position: absolute;
  top: 45%;
  right: 37%;
  margin: auto;
}
</style>
